<template>
  <div id="ctn-search-bar">
    <div class="d-flex flex-row justify-content-between">
      <div fluid class="d-flex flex-row"></div>
      <div fluid class="d-flex flex-row" id="search-bar">
        <b-input-group>
          <b-form-input placeholder="Bill of lading / Container" v-model="reference" required />
          <b-input-group-append>
            <b-button variant="success" @click.prevent="searchUnits(0)">SEARCH</b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div fluid class="d-flex flex-row" v-if="show_advanced_search">
        <b-button
          v-if="isLoggedIn"
          variant="primary"
          @click.prevent="toggleRefTypeBtn(3)"
          v-b-modal.modal-advanced-container-search
        >Advanced Search</b-button>
      </div>
    </div>
    <advancedSearch v-if="show_advanced_search" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import advancedSearch from "./ContainerAdvancedSearch.vue";

export default {
  name: "ContainerSearch",
  data: function () {
    return {
      advanced_search: false,
      ref_type: 0,
      ref_type_text: "Bill of lading",
      reference: "",
    };
  },
  methods: {
    toggleRefTypeBtn(ref_type) {
      this.ref_type = ref_type;
      if (ref_type == 3) {
        this.advanced_search = true;
        //this.$bvModal.show("modal-advanced-container-search");
      } else {
        this.advanced_search = false;
        //this.ref_type_text =
        //  this.ref_type == 1 ? "Bill of lading" : "Container";
      }
    },
    searchUnits(ref_type = 0) {
      this.ref_type = ref_type;

      let Type = this.ref_type;
      let action = "get_units";
      
      var client_id = this.$store.state.current_profile.id;
      var location;
      var status;
      var only_units_with_AR;
      if (this.ref_type==0 && this.reference == "") {
        alert("Please type the Bill of Lading or Container reference to search");
        return;
      }

      var payload;
      if (this.ref_type <= 2) {
        let reference = this.reference.replace(/\s+/g, "");
        if (reference == "") {
          alert("Please type a BL or Container reference");
          return false;
        }
        payload = { Type, reference };
      } else if (this.ref_type == 3) {
        payload = { Type, client_id };
      } else if (this.ref_type == 4) {
        location = "TERMINAL";
        status = "FULL";
        payload = { Type, client_id, location, status };
      } else if (this.ref_type == 5) {
        location = "CONSIGNEE";
        status = "FULL";
        payload = { Type, client_id, location, status };
      } else if (this.ref_type == 6) {
        status = "EMPTY";
        only_units_with_AR = "true";
        payload = { Type, client_id, status, only_units_with_AR };
      }

      this.$store.dispatch(action, payload);
      this.$emit("submit", payload);
    },
  },
  components: {
    advancedSearch,
  },
  computed: {
    ...mapState(["isLoggedIn", "current_profile"]),
    show_advanced_search(){
      return this.isLoggedIn && this.current_profile.type === 1;
    },
  },
};
</script>
